import { z } from "zod";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { consentChannelSchema, consentDecisionSchema, iysStatusSchema, messageChannelSchema, messagePermissionSourceChannelSchema, privacyTextKindSchema, } from "./enums.js";
/**
 * Rıza / aydınlatma defteri ve ticari elektronik ileti izni (ADR 0017 §7–8). İkisi de APPEND-ONLY defterdir: güncel durum
 * tür + amaç (ya da kanal) başına EN SON kayıttır. İleti izni kaydı yoksa izin YOKTUR (açık onay ilkesi).
 */
export const consentRecordSchema = z.object({
    id: uuidSchema,
    customerProfileId: uuidSchema,
    privacyTextId: uuidSchema,
    textTitle: z.string(),
    textRevision: z.number().int(),
    kind: privacyTextKindSchema,
    purposeCode: z.string().nullable(),
    decision: consentDecisionSchema,
    channel: consentChannelSchema,
    recordedAt: timestampSchema,
    recordedByUserId: uuidSchema.nullable(),
    recordedByDriverId: uuidSchema.nullable(),
    recordedByName: z
        .string()
        .nullable()
        .describe("Kaydeden personelin adı; sürücü kaydında 'Müşteri uygulaması'; bilinmiyorsa null"),
    evidenceFileId: uuidSchema
        .nullable()
        .describe("Kanıt dosyası; indirme adresi `GET …/consents/:consentId/evidence-link` (privacy.read)"),
    note: z
        .string()
        .nullable()
        .describe("`privacy.read` ya da `customers.personal.view` yoksa maskeli ('***')"),
});
export const consentEvidenceParamsSchema = z.object({ id: uuidSchema, consentId: uuidSchema });
export const messagePermissionSchema = z.object({
    id: uuidSchema,
    customerProfileId: uuidSchema,
    channel: messageChannelSchema,
    decision: z.enum(["GRANTED", "REVOKED"]),
    sourceChannel: messagePermissionSourceChannelSchema,
    privacyTextId: uuidSchema.nullable(),
    recordedAt: timestampSchema,
    recordedByUserId: uuidSchema.nullable(),
    recordedByDriverId: uuidSchema.nullable(),
    iysStatus: iysStatusSchema,
    iysAttempts: z.number().int(),
    iysSyncedAt: timestampSchema.nullable(),
    iysRef: z.string().nullable(),
    iysError: z.string().nullable(),
});
/** Müşterinin GÜNCEL KVKK durumu (müşteri 360 ve rıza ekranı). */
export const consentStateSchema = z.object({
    notice: z.object({
        acknowledged: z.boolean().describe("Aydınlatma metni okundu mu"),
        needsRefresh: z.boolean().describe("Yürürlükteki aydınlatma metni yeni sürüm: yeniden okutulmalı"),
        publishedTextId: uuidSchema.nullable(),
        acknowledgedTextId: uuidSchema.nullable(),
        acknowledgedAt: timestampSchema.nullable(),
    }),
    consents: z
        .array(z.object({
        kind: privacyTextKindSchema,
        purposeCode: z.string().nullable(),
        decision: consentDecisionSchema,
        active: z.boolean().describe("Açık rıza yürürlükte mi (en son karar GRANTED)"),
        privacyTextId: uuidSchema,
        channel: consentChannelSchema,
        recordedAt: timestampSchema,
    }))
        .describe("Tür + amaç başına en son kayıt (aydınlatma hariç)"),
    messagePermissions: z.array(z.object({
        channel: messageChannelSchema,
        granted: z.boolean(),
        decision: z.enum(["GRANTED", "REVOKED"]).nullable(),
        recordedAt: timestampSchema.nullable(),
        iysStatus: iysStatusSchema.nullable(),
    })),
});
export const customerConsentsSchema = z.object({
    state: consentStateSchema,
    history: z.array(consentRecordSchema).describe("Yeniden eskiye"),
});
export const recordConsentSchema = z.object({
    privacyTextId: uuidSchema.describe("YAYIMDAKİ metin sürümü"),
    decision: consentDecisionSchema.describe("Aydınlatma: ACKNOWLEDGED; rıza / ileti: GRANTED, DENIED, WITHDRAWN"),
    channel: consentChannelSchema,
    evidenceFileId: uuidSchema
        .nullable()
        .default(null)
        .describe("İmzalı form / kanıt dosyası (amaç CONSENT_EVIDENCE, yüklenmiş)"),
    note: z.string().trim().max(500).nullable().default(null),
});
export const customerMessagePermissionsSchema = z.object({
    current: consentStateSchema.shape.messagePermissions,
    history: z.array(messagePermissionSchema).describe("Yeniden eskiye"),
});
export const recordMessagePermissionSchema = z.object({
    channel: messageChannelSchema,
    decision: z.enum(["GRANTED", "REVOKED"]),
    sourceChannel: consentChannelSchema,
    privacyTextId: uuidSchema
        .nullable()
        .default(null)
        .describe("İzin verilirken ticari ileti metni (boşsa yürürlükteki COMMERCIAL_MESSAGE sürümü)"),
});
//# sourceMappingURL=consents.js.map